/** Relógio mutável lido no useFrame (sem re-render React). */
let liveDateUtc = new Date();

export function getLiveSimulationDate(): Date {
  return liveDateUtc;
}

export function setLiveSimulationDate(date: Date): void {
  liveDateUtc = date;
}

export function advanceLiveSimulationDate(deltaMs: number): Date {
  liveDateUtc = new Date(liveDateUtc.getTime() + deltaMs);
  return liveDateUtc;
}
